// extracted by mini-css-extract-plugin
module.exports = {"invoiceListContainer":"style_invoiceListContainer__2niBd"};